/**
 * Modal — reusable centered overlay dialog. Closes on backdrop click or Escape
 * and locks body scroll while open.
 */
import React, { useEffect } from 'react';

export default function Modal({ open, onClose, title, children, maxWidth = 460 }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="ev-modal" onMouseDown={onClose}>
      <div className="ev-modal__box" style={{ maxWidth }} onMouseDown={(e) => e.stopPropagation()}>
        <div className="ev-modal__head">
          <h3>{title}</h3>
          <button className="ev-modal__close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="ev-modal__body">{children}</div>
      </div>
    </div>
  );
}
